import { render } from "./ListeMedicament.vue?vue&type=template&id=3aeba264&scoped=true"
import script from "./ListeMedicament.vue?vue&type=script&lang=js"
export * from "./ListeMedicament.vue?vue&type=script&lang=js"

import "./ListeMedicament.vue?vue&type=style&index=0&id=3aeba264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aeba264"]])

export default __exports__